module.exports = __webpack_public_path__ + "img/Logo_Dojo.7f4d452b.png";